import { createSlice } from '@reduxjs/toolkit'

const messageList = createSlice({
    name: 'messageList',
    initialState: {
        list: [],//Все сообщения
        list_loaded: [] //Список загруженных чатов
    },
    reducers: {
        load(state, action) {
            const id_chat = parseInt(action.payload.id_chat);
 
            state.list = [...state.list.filter(a => a.ID_Chat !== id_chat), ...action.payload.list];
            state.list_loaded = [...state.list_loaded.filter(a => a.id_chat !== id_chat), { id_chat: id_chat }];
        },
        set(state, action) {
            const model = action.payload.model;
            state.list = [...state.list.filter(a => a.ID !== model.ID), model];
        },
    }
})

export const { load, set } = messageList.actions
export default messageList.reducer